/**
 * Business-calendar date presets for CS Reports verification.
 * Uses local browser calendar days as YYYY-MM-DD (admin portal convention).
 */

function toYmd(date) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

function startOfDay(date) {
  const d = new Date(date)
  d.setHours(0, 0, 0, 0)
  return d
}

function addDays(date, days) {
  const d = new Date(date)
  d.setDate(d.getDate() + days)
  return d
}

function startOfWeekMonday(date) {
  const d = startOfDay(date)
  const day = d.getDay() // 0 Sun .. 6 Sat
  const diff = day === 0 ? -6 : 1 - day
  return addDays(d, diff)
}

function startOfMonth(date) {
  const d = startOfDay(date)
  d.setDate(1)
  return d
}

export const REPORT_DATE_PRESETS = [
  { id: 'today', label: 'Today' },
  { id: 'yesterday', label: 'Yesterday' },
  { id: 'this_week', label: 'This week' },
  { id: 'last_week', label: 'Last week' },
  { id: 'this_month', label: 'This month' },
  { id: 'last_month', label: 'Last month' },
  { id: 'last_7', label: 'Last 7 days' },
  { id: 'last_15', label: 'Last 15 days' },
  { id: 'last_30', label: 'Last 30 days' },
  { id: 'custom', label: 'Custom' },
]

export function resolveReportDatePreset(presetId, now = new Date()) {
  const today = startOfDay(now)
  switch (presetId) {
    case 'today':
      return { startDate: toYmd(today), endDate: toYmd(today) }
    case 'yesterday': {
      const y = addDays(today, -1)
      return { startDate: toYmd(y), endDate: toYmd(y) }
    }
    case 'this_week': {
      const start = startOfWeekMonday(today)
      return { startDate: toYmd(start), endDate: toYmd(today) }
    }
    case 'last_week': {
      const thisMon = startOfWeekMonday(today)
      const lastMon = addDays(thisMon, -7)
      const lastSun = addDays(thisMon, -1)
      return { startDate: toYmd(lastMon), endDate: toYmd(lastSun) }
    }
    case 'this_month':
      return { startDate: toYmd(startOfMonth(today)), endDate: toYmd(today) }
    case 'last_month': {
      const firstThis = startOfMonth(today)
      const lastDayPrev = addDays(firstThis, -1)
      const firstPrev = startOfMonth(lastDayPrev)
      return { startDate: toYmd(firstPrev), endDate: toYmd(lastDayPrev) }
    }
    case 'last_7':
      return { startDate: toYmd(addDays(today, -6)), endDate: toYmd(today) }
    case 'last_15':
      return { startDate: toYmd(addDays(today, -14)), endDate: toYmd(today) }
    case 'last_30':
      return { startDate: toYmd(addDays(today, -29)), endDate: toYmd(today) }
    default:
      return null
  }
}
